import { render, staticRenderFns } from "./OfficeForApproval.vue?vue&type=template&id=935e2816&"
import script from "./OfficeForApproval.vue?vue&type=script&lang=js&"
export * from "./OfficeForApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports